import React, { useRef, useState, useEffect } from "react";
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import { Grid} from '@mui/joy';
import ProgressBar from "./ProgressBar";
import { Button, Typography } from "@mui/material";
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import styles from './styles'
// import DoughnutChartWithSliders from "./DoughnutChartWithSliders";

const Answer = (props) => {
  const { setCurrentScreen, question, answers } = props
  const { Title, QuestionMarkers, ActualText, ActualColor, ScoreText, ScorePercentage, ScorePercentageContainer, NextButton, DescriptionText } = styles;
  const maxNumber = Math.max(...(Object.values(answers)), ...(Object.values(question.actual)));
  let maxWidth = 80 / maxNumber; //slider length calculation.

  const calculatePercentage = () => {
    let answerPercentage = 0
    let avgSliderValue = 100 / 7;
    let keys = Object.keys(question.actual);
    for (let i = 0; i < 7; i++) {
      let difference = Math.abs(question.actual[keys[i]] - answers[keys[i]])
      answerPercentage += difference < 2 ? avgSliderValue : avgSliderValue - (difference - 1) >= 0 ? avgSliderValue - (difference - 1) : 0
      // difference = difference > 8 ? 0 : difference;
      // console.log("difference", difference)
      // answerPercentage += (8 - difference) * (avgSliderValue / 8);
    }
    return Math.round(answerPercentage);
  }
  return(
    <Grid container alignItems={'center'} justifyContent={'center'} >
      {/* check to mobile before push */}
      <Grid container spacing={2} padding={2} xs={12} justifyContent={'center'}>
        <Grid container xs={6} md={6}>
          <Title>
            {question.title}
            <Tooltip title="Source: Peter G. Peterson Foundation">
              <IconButton>
                <QuestionMarkers />
              </IconButton>
            </Tooltip>
          </Title>
          <Grid xs={12} container justifyContent={'center'}>
            <Grid xs={2}></Grid>
            <Grid container xs={3}>
              <ActualText >ACTUAL</ActualText>
              <ActualColor style={{ backgroundColor: "#003e4c" }} />
            </Grid>
            <Grid container xs={3}>
            <ActualText>GUESS</ActualText>
            <ActualColor style={{ backgroundColor: "#00b1d9" }} />
            </Grid>
            <Grid xs={4}></Grid>
          </Grid>

          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["Security"]} guess={answers['Security']} value={question.actual['Security']} name={"Social Security"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["Health"]} guess={answers['Health']} value={question.actual['Health']} name={"Health"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["Defense"]} guess={answers['Defense']} value={question.actual['Defense']} name={"Defense"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["Unemployment"]} guess={answers['Unemployment']} value={question.actual['Unemployment']} name={"Unemployment, Welfare and Other Relief"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["Interest"]} guess={answers['Interest']} value={question.actual['Interest']} name={"Interest on the Debt"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["Veteran"]} guess={answers['Veteran']} value={question.actual['Veteran']} name={"Veterans Benefits"} />
          <ProgressBar maxWidth={maxWidth} tooltipText={question.tooltip["Other"]} guess={answers['Other']} value={question.actual['Other']} name={"Other"} />
        </Grid>
        <Grid container xs={4} justifyContent={'center'} alignItems={'center'}>
          <Grid container xs={12} justifyContent={'center'} alignItems={'center'} style={{ flexDirection: 'column' }}>
            <ScoreText>YOUR SCORE</ScoreText>
            <ScorePercentageContainer container>
              <ScorePercentage>
              {calculatePercentage()}%
              </ScorePercentage>
            </ScorePercentageContainer>
            <DescriptionText>{question.description}</DescriptionText>
          </Grid>
        </Grid>
        <Grid container xs={1}></Grid>
      </Grid>
      <NextButton

      onClick={() => setCurrentScreen("Question")}
       >RESTART</NextButton>
    </Grid>
  )
}

// Use it if you don't plan to use "remount"
// document.addEventListener('DOMContentLoaded', () => {
  // ReactDOM.render(, document.getElementById('hello'))
// })

export default Answer
